const state = {
  users: {}
}

const getters = {

}

const actions = {
  requestUserList({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.userList()).then(function(response){
                  commit("_requestUserList", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserShow({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.userShow(payload)).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserMoneyBoxAssignmentIndex({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.userMoneyboxAssignmentIndex(payload)).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserSegmentAssignmentIndex({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.userSegmentAssignmentIndex(payload)).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },  
  requestUserCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;
    var ax = this._vm.$axios;
    return new Promise((resolve, reject) => {

      ax.post(api.userCreate(), payload).then(function(response){
                  
                  if(payload.selectedSegments.length) {

                    var promises = [];
                    payload.selectedSegments.forEach((item) => {
                      let promise = new Promise((resolve) => {
                        ax.post(api.userSegmentAssignmentCreate(response.data.id), {
                          segment_id: item.segmentId
                        }).finally(() => {
                          resolve()
                        })
                      })
                      promises.push(promise)
                    })

                    Promise.all(promises).then(()=> {
                      resolve(response.data)
                    })


                  }else{
                    resolve(response.data)
                  }
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserUpdate({commit}, payload){
    const api = this._vm.$apiEndpoints;
    var ax = this._vm.$axios;
    return new Promise((resolve, reject) => {

      ax.put(api.userUpdate(payload.id), payload).then(function(response){
        resolve(response.data)
      }).catch(function(response){
        reject(response)
      })
    })
  },
  requestUserMoneyboxAssignmentCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;
    const url = api.userMoneyboxAssignmentCreate(payload.user_id)
    var ax = this._vm.$axios;
    return new Promise((resolve, reject) => {
      
      var promises = []
      
      payload.selected_moneyboxes.forEach((item) =>{
        let prm = new Promise((resolve, reject) => {
          ax.post(url, {
              "moneybox_id": item.key
          }).finally(()=> {
            resolve()
          })
        })
        promises.push(prm)
      })

      Promise.all(promises).then(() => {
        resolve()
      })

    })
  },
  requestUserMoneyboxAssignmentDelete({commit}, payload){
    const api = this._vm.$apiEndpoints;
    var ax = this._vm.$axios;
    return new Promise((resolve, reject) => {
      
      var promises = []
      
      payload.deleted_moneyboxes.forEach((item) =>{
        let prm = new Promise((resolve, reject) => {
          const url = api.userMoneyboxAssignmentDelete(payload.user_id, item.key)
          ax.delete(url).finally(()=> {
            resolve()
          })
        })
        promises.push(prm)
      })

      Promise.all(promises).then(() => {
        resolve()
      })

    })
  },
  requestUserDelete({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.delete(api.userDelete(payload)).then(function(response){
                  commit("_requestUserDelete", payload)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  }
}

const mutations = {
  _requestUserList(state, payload){
    state.users = payload
  },
  _requestUserDelete(state, payload){
    state.users.users.splice(state.users.users.findIndex(item=>item.id == payload), 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
